import React, { createContext, useState, useEffect } from "react";
import apiEndpointList from "../../config/core_banking/endpoint";
import axios from "axios";
import { APIConfig } from "../../services/apiConfiguration";

export const PaymentsLinkContextProvider = createContext();

const PaymentsLinkContext = ({ children }) => {
  const [tableData, setTableData] = useState([]); //to Store the Table Data
  const [errorResponse, setErrorResponse] = useState();
  const [isError, setError] = useState(false);
  const [isLazyFetching, setIsLazyFetching] = useState(false); // If lazy fetching is active this can be used
  const [selectedTransaction, setSelectedTransaction] = useState("");
  const [isLoading, setIsLoading] = useState(false); // To handle loading state
  const [totalCount, setTotalCount] = useState(0); // To store the count info
  const [refreshing, setIsRefreshing] = useState(false);
  const [initialLoading, setInitialLoading] = useState(tableData?.length === 0); // To show the Skeleton instead of the overlay on the initial load
  const [newTokenVa, setNewToken] = useState(null); // To hold the token info
  const [noDataFound, setNoDataFound] = useState(false); // If no data is present
  const [firstApiCall, setfirstApiCall] = useState(true); // To judge whether the Table is getting reset or not
  const [showModalDialog, setShowModalDialog] = useState(false); // To use to control show of modals
  let [totalcountNotset, settotalcountNotset] = useState(true);
  const [searchParameter, setSearchParameter] = useState({
    bank_ref_number: false,
    decentro_urn: false,
    customer_ref_number: false,
  });
  const [currentSearchScope, setCurrentSearchScope] = useState("");
  const limit = 200; // Can be changed kept constant for now
  const [filterList, setFilterList] = useState({
    search: "",
    resultsPerPage: 10,
    currentPage: 1,
  });
  let lastInterval;
  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 14);
  const [dateFilters, setDateFilters] = useState([
    initialStartDate,
    new Date(),
  ]);
  const getDateFormatted = (date) => {
    const dateObj = new Date(date);
    const month = dateObj.getMonth() + 1;
    const dateTime = dateObj.getDate();
    return `${dateObj.getFullYear()}-${month > 9 ? month : `0${month}`}-${
      dateTime > 9 ? dateTime : `0${dateTime}`
    }`;
  };
  const [lastApiTime, setLastApiTime] = useState(0); // To handle the timer

  const fetchData = async (
    lastItem,
    filterData,
    customDate,
    clearOld,
    isLazy
  ) => {
    if (filterList.search && isLazy) return;

    if (!isLazy && firstApiCall) {
      setIsLoading(true); // To Change the loading state
    } else {
      setIsLazyFetching(true); // To Handle Lazy loading
    }
    if (newTokenVa) {
      newTokenVa.cancel(); // To handle the previous placed api call
      setNewToken(null); // To set the initial value to NULL
    }
    const newToken = axios.CancelToken.source();
    setNewToken(newToken);

    let filters = filterData ?? filterList;
    let dateData = customDate ?? dateFilters;
    const countApiPath =
      apiEndpointList.FETCH_PAYMENT_LINKS_COUNT.baseUrl +
      apiEndpointList.FETCH_PAYMENT_LINKS_COUNT.endpoint;

    const dataApiPath =
      apiEndpointList.FETCH_PAYMENT_LINKS.baseUrl +
      apiEndpointList.FETCH_PAYMENT_LINKS.endpoint;
    const startIndex = (filterList.currentPage - 1) * filterList.resultsPerPage; // To judge the start of the page will not change
    const endIndex = startIndex + filterList.resultsPerPage; // Depending upon the entries per page this will change on the initial call
    const searchTerm = filters?.search !== "" ? filters.search : null; // To handle the search term
    let body = {
      ...(searchTerm
        ? searchParameter.decentro_urn
          ? {
              decentro_company_urn: searchTerm,
              limit,
              offset: (Math.ceil((lastItem ?? endIndex) / limit) - 1) * limit,
            }
          : searchParameter.customer_ref_number
          ? {
              customer_reference_number: searchTerm,
              limit,
              offset: (Math.ceil((lastItem ?? endIndex) / limit) - 1) * limit,
            }
          : searchParameter.bank_ref_number
          ? {
              bank_reference_number: searchTerm,
              limit,
              offset: (Math.ceil((lastItem ?? endIndex) / limit) - 1) * limit,
            }
          : {
              decentro_company_urn: searchTerm,
              limit,
              offset: (Math.ceil((lastItem ?? endIndex) / limit) - 1) * limit,
            }
        : {
            limit,
            end_date: getDateFormatted(dateData[1]),
            offset: (Math.ceil((lastItem ?? endIndex) / limit) - 1) * limit,
            start_date: getDateFormatted(dateData[0]),
          }),
    };

    const userData = APIConfig.API_Client.post(dataApiPath, body, {
      cancelToken: newToken.token, // to retrieve the Table data
    })
      .then((res) => {
        setIsRefreshing(false);
        setInitialLoading(false);
        setIsLazyFetching(false);
        if (res.data) {
          if ((filters.currentPage === 1 || clearOld) && !isLazy) {
            setTableData(res.data); // To set the data initially
          } else {
            setTableData([...tableData, ...res.data]); // To append the data into existing list
          }
        }
        return res.data;
      })
      .catch((e) => {
        if (!axios.isCancel(e)) {
          setError(true);
          setErrorResponse(e);
        }
      });

    let promiseList = [userData];
    if (!isLazy && firstApiCall) {
      const dataCount = APIConfig.API_Client.post(countApiPath, body, {
        cancelToken: newToken.token,
      }).then((res) => {
        return res.data;
      });
      promiseList.push(dataCount);
    }
    axios
      .all(promiseList)
      .then((res) => {
        setIsLoading(false);
        setIsLazyFetching(false);
        if (!res[0]?.length) {
          setNoDataFound(true);
        }

        setTotalCount(res[1][0].total_count);
      })
      .catch((e) => {});
  };

  function refreshTable() {
    setShowModalDialog(false);
    setNoDataFound(false);
    setInitialLoading(true);
    setfirstApiCall(true);
    clearInterval(lastInterval);
    setFilterList({ ...filterList, currentPage: 1 });
    fetchData(1, { ...filterList, currentPage: 1 }, undefined, true);
  }

  useEffect(() => {
    lastInterval = setInterval(() => {
      setLastApiTime((pre) => pre + 1);
    }, 60000);
    return () => {
      if (lastInterval) {
        clearInterval(lastInterval);
      }
      if (newTokenVa) {
        newTokenVa.cancel();
      }
    };
  }, []);

  return (
    <PaymentsLinkContextProvider.Provider
      value={{
        setDateFilters,
        setFilterList,
        setInitialLoading,
        setIsLazyFetching,
        setIsLoading,
        setNewToken,
        setSelectedTransaction,
        setTotalCount,
        setTableData,
        fetchData,
        setNoDataFound,
        getDateFormatted,
        isLazyFetching,
        isLoading,
        tableData,
        filterList,
        limit,
        totalCount,
        noDataFound,
        initialLoading,
        selectedTransaction,
        dateFilters,
        lastApiTime,
        setLastApiTime,
        lastInterval,
        settotalcountNotset,
        isError,
        errorResponse,
        refreshTable,
        setShowModalDialog,
        showModalDialog,
        refreshing,
        setIsRefreshing,
        isError,
        errorResponse,
        setError,
        setErrorResponse,
        setfirstApiCall,
        firstApiCall,
        searchParameter,
        setSearchParameter,
        currentSearchScope,
        setCurrentSearchScope,
      }}
    >
      {children}
    </PaymentsLinkContextProvider.Provider>
  );
};

export default PaymentsLinkContext;
